<template>
    <div class="geography">
        <div class="geography__text">
            <h2 class="section-title">География перевозок</h2>
            <p class="geography__subtitle">
                ПЭК оказывает услуги авто — и авиаперевозок из Беларуси в Россию, Армению, Казахстан, Киргизию и Узбекистан,
                а также автоперевозок в обратном направлении. Вы можете сдать груз в отделениях компании в Минске,
                Бресте, Витебске, Гомеле, Гродно, Могилёве или заказать доставку «от двери до двери».
            </p>
        </div>
        <div class="geography__card">
            <p class="geography__card-title">
                Примеры направлений грузоперевозки*
            </p>
            <div class="geography__card-wrapper">
                <div class="embla" ref="emblaRef">
                    <div class="embla__container">
                        <div class="embla__slide" v-for="item in geographySlides" :key="item.title">
                            <div class="geography__card-item">
                                <img class="geography__card-item-img"
                                        :src="item.src"
                                        :alt="item.alt"
                                        loading="lazy" />
                                <p class="geography__card-item-title">{{ item.title }}</p>
                                <p class="geography__card-item-description">{{ item.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p class="geography__card-description">*Авто, тариф до 100 кг</p>
        </div>
        <button class="geography__button" @click="scrollToContentInfo"><p class="geography__button-text">Онлайн-расчёт стоимости перевозки</p></button>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import useEmblaCarousel from 'embla-carousel-vue';
import { useBreakpoints, isClient } from '@vueuse/core';

const breakpoints = useBreakpoints({ desktop: 1279 });
const isMobile = breakpoints.smaller('desktop');

const emblaOptions = computed(() => ({
    active: isMobile.value,
    loop: false,
    align: 'start'
}));

const [emblaRef, emblaApi] = isClient
  ? useEmblaCarousel(emblaOptions)
  : [ref(), ref()];

const scrollToContentInfo = () => {
    if (window.dataLayer) {
        window.dataLayer.push({'event': 'calc_button_by'});
    }
    const contentInfo = document.querySelector('.content-info');
    if (contentInfo) {
        contentInfo.scrollIntoView ({behavior : 'smooth'})
    }
}
const geographySlides = [
    {
        src: "/images/home/by_1.png",
        alt: "Москва → Минск",
        title: "Москва → Минск",
        description: "От 2 дней, 21,9 ₽/кг"
    },
    {
        src: "/images/home/by_2.png",
        alt: "Москва → Брест",
        title: "Москва → Брест",
        description: "От 3 дней, 32,6 ₽/кг"
    },
    {
        src: "/images/home/by_3.png",
        alt: "Санкт-Петербург → Гомель",
        title: "Санкт-Петербург → Гомель",
        description: "От 5 дней, 36,8 ₽/кг"
    },
    {
        src: "/images/home/by_4.png",
        alt: "Санкт-Петербург → Могилёв",
        title: "Санкт-Петербург → Могилёв",
        description: "От 5 дней, 36,8 ₽/кг"
    },
    {
        src: "/images/home/by_5.png",
        alt: "Краснодар → Минск",
        title: "Краснодар → Минск",
        description: "От 6 дней, 32,6 ₽/кг"
    }
]
</script>

<style scoped>
.geography {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    overflow: hidden;
}
.geography__text{
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.geography__subtitle {
    font-weight: 400;
    font-style: Regular;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    margin: 0;
}
.geography__card {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.geography__card-title {
    font-weight: 500;
    font-style: Medium;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}
.geography__card-wrapper {
    position: relative;
}

.embla__container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: flex-start;
}

.embla__slide {
    flex: 0 0 246px;
    min-width: 0;
}

.geography__card-item {
    padding: 16px;
    background-color: #F5F5F5;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 220px;
    width: 100%;
}
.geography__card-item-img {
    border-radius: 12px;
    width: 214px;
    height: 100px;
}
.geography__card-description {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    color: #AAAAAA;
    margin: 0;
}
.geography__card-item-title {
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}
.geography__card-item-description {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    color: #757575;
    margin: 0;
}
.geography__button {
    max-width: 340px;
    padding: 16px 28px;
    color: #FFFFFF;
    background-color: #E4003C;
    border-radius: 6px;
    border: none;
}
.geography__button-text {
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    margin: 0;
}
.section-title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    leading-trim: NONE;
    line-height: 46px;
    letter-spacing: 0%;
    margin: 0;
}

@media screen and (max-width: 1279px) {
    .section-title {
        font-size: 24px;
        line-height: 32px;
    }

    .embla {
        overflow: hidden;
    }
    .embla__container {
        flex-wrap: nowrap;
    }
}
@media screen and (max-width: 768px) {
    .section-title {
        font-size: 22px;
        line-height: 28px;
    }
    .geography__subtitle {
        font-size: 16px;
        line-height: 24px;
    }
}
@media screen and (max-width: 768px) {
    .geography {
        margin-top: 40px;
    }
}
</style>
